import { render, staticRenderFns } from "./hotelMsgManage.vue?vue&type=template&id=3115744a&"
import script from "./hotelMsgManage.vue?vue&type=script&lang=js&"
export * from "./hotelMsgManage.vue?vue&type=script&lang=js&"
import style0 from "./hotelMsgManage.vue?vue&type=style&index=0&id=3115744a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports